// ----------------------------------------------------------------------
// <copyright file="Izenda.NotificationConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
//

import localizer from 'share/localization/Izenda.Localizer';

export default {
  get MODULES(){
    return {
      EXPORT_QUEUE: { 
        value: 'ExportQueue', 
        title: localizer.getText('NOTIFICATION_POPUP_EXPORT_TYPE_TITLE')
      },
      PROVISION_MAP:{ 
        value: 'ProvisionMap', 
        title: localizer.getText('NOTIFICATION_POPUP_MAP_TYPE_TITLE')
      }
    }
  },
  get MESSAGES_LIST(){
    return [
      {
        id: 1,
        module: this.MODULES.EXPORT_QUEUE,
        template: localizer.getText('NOTIFICATION_POPUP_EXPORT_SUCCESS_MESSAGE_TEMPLATE')
      },
      {
        id: 2,
        module: this.MODULES.EXPORT_QUEUE,
        template: localizer.getText('NOTIFICATION_POPUP_EXPORT_READY_MESSAGE_TEMPLATE')
      },
      {
        id: 3,
        module: this.MODULES.EXPORT_QUEUE,
        template: localizer.getText('NOTIFICATION_POPUP_EXPORT_FAILED_MESSAGE_TEMPLATE')
      },
      {
        id: 4,
        module: this.MODULES.PROVISION_MAP,
        template: localizer.getText('NOTIFICATION_POPUP_MAP_STARTED_MESSAGE_TEMPLATE')
      },
      {
        id: 5,
        module: this.MODULES.PROVISION_MAP,
        template: localizer.getText('NOTIFICATION_POPUP_MAP_SUCCESS_MESSAGE_TEMPLATE')
      },
      {
        id: 6,
        module: this.MODULES.PROVISION_MAP,
        template: localizer.getText('NOTIFICATION_POPUP_MAP_ERROR_MESSAGE_TEMPLATE')
      }
    ]
  },
  get MESSAGES(){
    return {
      EXPORT_QUEUE_FILE_CREATED: this.MESSAGES_LIST[0],
      EXPORT_QUEUE_FILE_READY: this.MESSAGES_LIST[1],
      EXPORT_QUEUE_FILE_FAILED: this.MESSAGES_LIST[2],
      PROVISION_MAP_STARTED: this.MESSAGES_LIST[3],
      PROVISION_MAP_SUCCESSFUL: this.MESSAGES_LIST[4],
      PROVISION_MAP_FAILED: this.MESSAGES_LIST[5]
    }
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.NotificationConstants.js